import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import DefaultTheme from './theme';
import Accordion from '../accordion';
import PrimaryButton from '../buttons/primary';
/*::
import type { Node } from 'react';

export type LogisticsAccordionEntry = {|
  title: string;
  imageUrl?: string;
  imageAlt?: string;

  // If supplied, will take precedence over imageUrl
  imageNode?: Node;

  color: string;
  logoUrl: string;
  logoAlt?: string;
  text: string;
  buttonLabel: string;
  buttonUrl: string;
|}

export type Props = {|
  entries: LogisticsAccordionEntry[],
  linkComponent?: Node,
  theme?: any,
  rest?: any,
|}
*/

var LogisticsAccordion = function LogisticsAccordion(_ref
/*: Props */
) {
  var _ref$entries = _ref.entries,
      entries = _ref$entries === void 0 ? [] : _ref$entries,
      _ref$linkComponent = _ref.linkComponent,
      linkComponent = _ref$linkComponent === void 0 ? 'a' : _ref$linkComponent,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["entries", "linkComponent", "theme"]);

  return /*#__PURE__*/React.createElement(theme.Main, null, /*#__PURE__*/React.createElement(Accordion, Object.assign({
    jsxPanels: entries.map(function (entry) {
      return {
        head: /*#__PURE__*/React.createElement(theme.Head, null, entry.imageNode ? entry.imageNode : /*#__PURE__*/React.createElement(theme.HeadImage, {
          src: entry.imageUrl,
          alt: entry.imageAlt,
          loading: "lazy"
        }), /*#__PURE__*/React.createElement(theme.HeadDarker, null), /*#__PURE__*/React.createElement(theme.HeadIcon, null), /*#__PURE__*/React.createElement(theme.Title, null, entry.title)),
        body: /*#__PURE__*/React.createElement(theme.Body, {
          color: entry.color
        }, /*#__PURE__*/React.createElement(theme.Logo, {
          src: entry.logoUrl,
          alt: entry.logoAlt,
          loading: "lazy"
        }), /*#__PURE__*/React.createElement(theme.Text, null, entry.text), /*#__PURE__*/React.createElement(PrimaryButton, {
          href: entry.buttonUrl || '#',
          linkComponent: linkComponent,
          theme: theme.Button
        }, entry.buttonLabel))
      };
    }),
    theme: theme.AccordionTheme
  }, rest)));
};

export default LogisticsAccordion;